import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class IsLeaderService {

  public uri = this.environmentService.getEnvVar('api_agent');

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService) { }

  public getIsLeader() {
    return this.http.get<any>(`${this.uri}/is-leader`);
  }
}
